import Response from './../_response';

class ExpenseTypesEndpoint {
  constructor(client) {
    this._client = client;
  }

  query() {
    return this._client
      .fetch('expense_types', 'GET')
      .then(({ response, json }) => {
        return new Response(response, json);
      });
  }

  create(data) {
    return this._client
      .fetch('expense_types', 'POST', data)
      .then(({ response, json }) => {
        return new Response(response, json);
      });
  }

  update(data) {
    return this._client
      .fetch(`expense_types/${data.id}`, 'PATCH', data)
      .then(({ response, json }) => {
        return new Response(response, json);
      });
  }

  destroy(id) {
    return this._client
      .fetch(`expense_types/${id}`, 'DELETE')
      .then(({ response, json }) => {
        return new Response(response, json);
      });
  }
}

export default ExpenseTypesEndpoint;
